module.exports = __webpack_public_path__ + "img/Chemin_de_table_mariage.b7447dc.jpg";